export default {
  VALIDATIONS_FETCHED: 'VALIDATIONS_FETCHED',
  VALIDATION_LOAD: 'VALIDATION_LOAD',
  VALIDATION_DETAIL: 'VALIDATION_DETAIL',
  VALIDATION_BUTTON_LOAD: 'VALIDATION_BUTTON_LOAD',
};
